import { makeSelectors } from '@utils/css';

const modifiers = makeSelectors({
  withIcon: "_rsw1ec7hbs"
});
const linkCls = "_rslg2cr1i";
const secondaryThemeChevronCls = "_rssuwa407";
const themeIconCls = "_rst174ktus";

export { linkCls, modifiers, secondaryThemeChevronCls, themeIconCls };
import "./link.styles.linaria.module.css";
//# sourceMappingURL=link.styles.js.map
